import React from 'react';
import FontAwesome from 'react-fontawesome';

const PageNotFound = () => {

  return <div className='container flex-container flex-vertical flex-align-center flex-justify-around'>
    <h1 className='mt-5 mb-3'>Oh NOES!</h1>
    <h2 className='flex-element'>
      <FontAwesome name='chain-broken'/> You've found a link that doesn't exist!  If you believe you should have access to this url, please contact <a href='mailto:support@ignitesales.com'>Ignite Sales Technical Support</a> and we will work with you to find a solution.  Cool beans.
    </h2>
  </div>;
};

export default PageNotFound;




// WEBPACK FOOTER //
// ./src/components/PageNotFound.js